import { render, staticRenderFns } from "./GyFooter.vue?vue&type=template&id=0e110410&scoped=true&"
import script from "./GyFooter.vue?vue&type=script&lang=js&"
export * from "./GyFooter.vue?vue&type=script&lang=js&"
import style0 from "./GyFooter.vue?vue&type=style&index=0&id=0e110410&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e110410",
  null
  
)

export default component.exports